import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useModifyAnExchange } from './useModifyAnExchange';
import { isActionParamEqualTo } from '../../../utils/action-params';
import { MODIFY_EXCHANGE_MODAL } from '../../../constants/action-params';
import { fetchConversation } from '../../../actions/conversations';
var _OpenMAEModal = function (_a) {
    var conversation = _a.conversation, availabilities = _a.availabilities, user = _a.user, interlocutorAvailabilities = _a.interlocutorAvailabilities, fetchConversation = _a.fetchConversation;
    var _b = useModifyAnExchange({
        conversation: conversation,
        availabilities: availabilities,
        user: user,
        interlocutorAvailabilities: interlocutorAvailabilities,
        fetchConversation: fetchConversation
    }), canModify = _b.canModify, showModifyExchangeModal = _b.showModifyExchangeModal, conversationHasModification = _b.conversationHasModification;
    useEffect(function () {
        if (canModify() && !conversationHasModification && isActionParamEqualTo(MODIFY_EXCHANGE_MODAL)) {
            showModifyExchangeModal();
        }
    }, [showModifyExchangeModal, canModify]);
    return null;
};
function mapStateToProps(state, ownProps) {
    return {
        availabilities: state.availabilities[ownProps.conversation.getExchange().get('home').id],
        interlocutorAvailabilities: ownProps.conversation.isMutual()
            ? state.availabilities[ownProps.conversation.getExchangeAsHost().get('home').id]
            : []
    };
}
var mapDispatchToProps = function (dispatch) { return ({
    fetchConversation: bindActionCreators(fetchConversation, dispatch)
}); };
export var OpenMAEModal = connect(mapStateToProps, mapDispatchToProps)(_OpenMAEModal);
